import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { ForYouSection } from './components/ForYouSection';
import { WhatsInside } from './components/WhatsInside';
import { Outcomes } from './components/Outcomes';
import { PurchaseSection } from './components/PurchaseSection';
import { Bonuses } from './components/Bonuses';
import { Reviews } from './components/Reviews';
import { Faq } from './components/Faq';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-full w-full overflow-x-hidden bg-cream-100 font-sans" data-id="element-0" data-mp="2mjpvbd7vxaer">
      <main className="bg-grid mx-auto w-full max-w-[460px] overflow-x-hidden" data-id="element-1" data-mp="31c9ts0k3atpv">
        <Hero data-id="element-2" data-mp="2wiyvintcfl9k" />
        <ForYouSection data-id="element-3" data-mp="2wiffxdr618yp" />
        <WhatsInside data-id="element-4" data-mp="2whxd1y9zzwht" />
        <Outcomes data-id="element-5" data-mp="28u5xmlt5v3cb" />
        <PurchaseSection data-id="element-6" data-mp="28tmdcyg1g2v4" />
        <Bonuses data-id="element-7" data-mp="28sutulzptvl7" />
        <Reviews data-id="element-8" data-mp="28sbcb6dz997p" />
        <Faq data-id="element-9" data-mp="23vcjqs9ypabm" />
      </main>
    </div>;
}